import React from "react";
import "../App.css";

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useNavigate } from "react-router-dom";

const faqData = [
  {
    question: "How can I sign up on RewardDay App?",
    answer: "Go to Signup, enter your phone number, receive OTP, and you’re ready to earn rewards.",
  },
  {
    question: "What are the methods to earn rewards on RewardDay?",
    answer: "1. Avail offers\n2. Refer friends\n3. Daily check-in for rewards",
  },
  {
    question: "How can I avail an offer?",
    answer: "Click an offer → Read instructions → Complete steps → Get RewardDay tokens after confirmation.",
  },
  {
    question: "When will tokens be added to my wallet?",
    answer: "Once confirmation is received from the advertiser, tokens are credited instantly or within 24 hours.",
  },
  {
    question: "How many RewardDay tokens make ₹1?",
    answer: "1 RewardDay Token = ₹1",
  },
];

function Home() {
    const navigate  = useNavigate()
  return (
    <div className="app">
      {/* Faint background circles */}
      <div className="background-circles">
        <div className="circle circle1"></div>
        <div className="circle circle2"></div>
      </div>

      <div className="header">
        <img src="/logo.png" alt="RewardDay Logo" className="logo" />
        <text className="logo-text">RewardDay</text>
      </div>

      {/* Hero Section */}
      <header className="hero">
        <div className="hero-content">
          <text className="primary-content">
            The best Way to<br />
            <span style={{ backgroundColor: '#8056B2', color: '#fff', padding: '0px 5px' }}>
              earn money instantly
            </span><br />
            with India’s newest Earning app
          </text>
          <text className="secondary-content">
            Earning money is never easy, it takes hard work and passion but how about we make it easy for you? Presenting you the newest application where you can earn money instantly.
          </text>
          <div className="button">
            <div className="btn-text">Download our Mobile<br /> app</div>
            <a href="https://play.google.com/store/apps/details?id=com.rewardday" target="_blank" rel="noopener noreferrer" className="btn-botton">
              <img src="/play-store.png" alt="play store app link" style={{ width: '100%' }} />
            </a>
          </div>
        </div>
        <div className="hero-image">
          <img src="/banner.png" alt="Banner image" style={{ width: '100%' }} />
        </div>
      </header>

      {/* FAQ Section */}
      <main className="faq">
        <h2>Frequently Asked Questions</h2>
        <div className="faq-list">
          {faqData.map((item, index) => (
            <Accordion key={index} style={{ marginBottom: '8px', backgroundColor: '#FFF6FF', padding: '5px' }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon style={{ fontSize: '15px' }} />}
                aria-controls="panel1-content"
                id={`panel${index}-header`}
              >
                <Typography component="span">{item?.question}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                {item?.answer}
              </AccordionDetails>
            </Accordion>
          ))}
        </div>
      </main>

      {/* Footer */}
      <footer>
        <div className="footer-links">
          <div onClick={() => navigate('/policy')} style={{cursor:'pointer'}} >Privacy Policy</div>
          <div onClick={() => navigate('/terms&condition')} style={{cursor:'pointer'}} >Terms & Conditions</div>
          {/* <div>Contact Us</div> */}
        </div>
        <p>© 2025 rewardday.in</p>
      </footer>
    </div>
  );
}

export default Home;
